import React from 'react';

import mapValues from 'lodash/mapValues';
import find from 'lodash/find';

import { Field } from 'redux-form';

import withIntl from '../../../../../../../shared/intl-hoc';
import withCheckPermission from '../../../../../../../shared/check-permission-hoc';

import { isRequired } from '../../../../../../../shared/form/validation';
import InputField from '../../../../../../../shared/form-elements/input';
import CheckboxField from '../../../../../../../shared/form-elements/checkbox';

import { enum as permissions } from '../../../../../../../../../../../enums/admin-permissions';
import { enum as payoutSystemTypes } from '../../../../../../../../../../../enums/payout-system-types';

import sortKeys from '../../../../../../../../../../shared/js/sort';
import { getCurrencyIcon } from '../../../../../../../../../../shared/js/get-currency-icon';

import AddPayoutSystemButton from './add-payout-system-button/main';

function AffiliatePayoutSystemSettings({
	intl, check, fields, payoutSystems, allowedPayoutSystems, removeSystem, changeField
}) {
	const isAutoConfirmSettingsShown =
		window.globalConfig
		&& window.globalConfig.isAutomaticPayoutConfirmationAbilityEnabled
		&& check(permissions.payoutsChangeAutoConfirmSettings);

	return (
		<div>
			<div className='add-system__container'>
				{allowedPayoutSystems.length > 0 && (
					<AddPayoutSystemButton
						allowedPayoutSystems={allowedPayoutSystems}
						addPayoutSystemSettingField={(payoutSystem) => {
							fields.unshift({
								payout_system_id: payoutSystem.id,
								credentials: mapValues(payoutSystem.fields, () => ''),
								autoconfirm_settings: {
									max_payout_amount_for_automatic_confirmation: '',
									max_payout_number_for_automatic_confirmation: '1'
								},
								is_auto_payout_confirm_enabled: false
							});

							setTimeout(() => changeField('payout-system', null), 0);
						}}
					/>
				)}
			</div>
			{fields.map((member, index) => {
				const field = fields.get(index);

				const payoutSystem = find(payoutSystems, { id: field.payout_system_id });

				if (!payoutSystem) {
					return;
				}

				const isAutomaticPayoutSystem = payoutSystem.type === payoutSystemTypes.automatic;

				return (
					<div className='payout-system' key={index}>
						<h3 className='title'>
							{payoutSystem.title} ({getCurrencyIcon(payoutSystem.currency)})
						</h3>
						<span
							className="payout-system_delete delete"
							onClick={() => {
								if (field.id) {
									removeSystem(field.id, payoutSystem.title);
								} else {
									fields.remove(index);
								}
							}}
						/>
						{sortKeys(payoutSystem.fields).map((payoutSystemField, i) => (
							<Field
								name={`${member}.credentials.${payoutSystemField}`}
								component={InputField}
								placeholder={payoutSystemField}
								showLabel={false}
								key={i}
							/>
						))}
						{isAutoConfirmSettingsShown && isAutomaticPayoutSystem && (
							<div>
								<Field
									name={`${member}.is_auto_payout_confirm_enabled`}
									component={CheckboxField}
									placeholder={intl('Is auto payout confirm enabled')}
								/>
								{field.is_auto_payout_confirm_enabled && (
									<div>
										<Field
											name={`${member}.autoconfirm_settings.max_payout_amount_for_automatic_confirmation`}
											placeholder='max payout amount for automatic confirmation'
											component={InputField}
											validate={[isRequired]}
											showLabel={false}
										/>
										<Field
											name={`${member}.autoconfirm_settings.max_payout_number_for_automatic_confirmation`}
											placeholder='max payout number for automatic confirmation'
											component={InputField}
											validate={[isRequired]}
											showLabel={false}
										/>
									</div>
								)}
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
}

export default withIntl(withCheckPermission(AffiliatePayoutSystemSettings));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/payout-settings/payout-settings-form/affiliate-payout-system-settings/main.js